<template>
  <div id="app" class="wrapper">
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <div class="cart">
        <br />
        <h1 class="title cor-preta">Meus Pedidos</h1>
        <h2>
          <b
            ><label class="cor-preta"
              >Pedidos na {{ vendas[0].serie }} {{ vendas[0].num_serie }}</label
            ></b
          >
        </h2>
        <br />
        <!--<p v-show="!products.length">
				<i>Meu carrinho de pedidos está vazio! </i>
				<router-link to="/">Vamos pedir!</router-link>
			</p>
			<table class="table is-striped" v-show="products.length">-->
        <table class="table is-striped">
          <thead>
            <tr>
              <!--<td><label class="cor-preta"><b>Código</b></label></td>-->
              <td>
                <label class="cor-preta"><b>Pedido</b></label>
              </td>
              <td>
                <label class="cor-preta"><b>Qtd</b></label>
              </td>
              <td>
                <label class="cor-preta"><b>Vl. Un.</b></label>
              </td>
              <td>
                <label class="cor-preta"><b>Subtotal</b></label>
              </td>
              <!--<td><label class="cor-preta"><b>Status</b></label></td>
						<td><label class="cor-preta"><b>Serie</b></label></td>
						<td><label class="cor-preta"><b>Num Serie</b></label></td>-->
              <!--<td><label class="cor-preta"><b>MESA</b></label></td>-->
            </tr>
          </thead>
          <tbody>
            <tr v-for="venda of vendas" :key="venda.cd">
              <!--<td><label class="cor-preta" ><b>{{ venda.cd_venda }}</b></label></td>-->
              <td>
                <label class="cor-preta"
                  ><b>{{ venda.nm_prod }} </b></label
                ><label class="letra-media cor-preta">
                  <span>{{ venda.obs }}</span>
                </label>
              </td>
              <td>
                <label class="cor-preta"
                  ><b>{{ parseInt(venda.qtd).toFixed(0) }}</b></label
                >
              </td>
              <td>
                <label class="cor-preta"
                  ><b>R${{ venda.vl_unit }}</b></label
                >
              </td>
              <td>
                <label class="cor-preta"
                  ><b>R$ {{ venda.subtot }}</b></label
                >
              </td>
              <!--<td><label class="cor-preta" ><b>{{ venda.status }}</b></label></td>
						<td><label class="cor-preta" ><b>{{ venda.serie }}</b></label></td>
						<td><label class="cor-preta" ><b>{{ venda.num_serie }}</b></label></td>-->
              <!--<td><label class="cor-preta" ><b>{{ venda.mesa }}</b></label></td>-->
            </tr>
          </tbody>
        </table>
        <!--<b><span v-show="products.length">Total Produto: R$ {{ parseFloat(totalp).toFixed(2) }}</span></b><br><br>-->

        <h4>
          <b
            ><label class="cor-preta"
              >Total: R$ {{ parseFloat(total).toFixed(2) }}</label
            ></b
          >
        </h4>
        <br />

        <!--<b>Alguma observação ?</b>
			<textarea class="form-control" v-model="obs" id="obs" name="obs" rows="1" placeholder="Ex: Digite as observações aqui..."></textarea><br>-->
        <!--<h5>Pedido na <div id="minhadiv"></div></h5><br>-->
        <p>
          <router-link to="/" class="btn btn-dark"
            >Continuar Pedindo</router-link
          >
        </p>
        <br />
        <!--<p><button class='btn btn-dark' @click='salvarvendaproduto(products, total)'>Finalizar Pedido</button></p><br>-->
      </div>
    </div>
    <br />
    <footer class="main-footer" align="center">
      <b class="cor-preta">Todos os direitos reservados.</b><br />
      <b class="cor-preta"
        >&copy; 2022
        <a target="”_blank”" href="https://www.panterafood.com.br"
          >Pantera Food</a
        >.</b
      ><br />
      <img
        width="100"
        src="https://apppanterafood.com.br/DeliveryCenter/3/logo/pantera.svg"
      />
    </footer>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Cardapio from "../services/cardapio";
import store from "../store/index.js";
import Adicional from "../services/adicional";
import Ordem from "../services/nome_ordem";
import Contrato from "../services/contrato";
import Venda from "../services/venda";
import ItemVenda from "../services/item_venda";

export default {
  name: "Pedidos",
  data() {
    return {
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
        serie: "",
        num_serie: "",
        mesa: "",
      },
      item_vendas: [],
      item_venda: {
        cd: "",
        cd_venda: "",
        cd_prod: "",
        nm_prod: "",
        vl_unit: "",
        qtd: "",
        subtot: "",
        unid: "",
        obs: "",
        vl_adicionais: "",
        tab_nacional: "",
      },
    };
  },
  computed: {
    /*...mapGetters({
	products: 'cartProducts'	
	}),*/
    total() {
      return this.vendas.reduce((total, venda) => {
        return total + venda.vl_unit * venda.qtd;
      }, 0);
    },
  },
  methods: {
    //listarvenda
    listarvenda(venda) {
      var v = new Object();

      if (
        localStorage.getItem("serie") == "COMANDA" ||
        localStorage.getItem("serie") == "comanda" ||
        localStorage.getItem("serie") == "CARTAO" ||
        localStorage.getItem("serie") == "cartao"
      ) {
        //var resposta=prompt("Qual o número da mesa que você está ?");

        //v.mesa = resposta;
        v.serie = localStorage.getItem("serie");
        v.num_serie = localStorage.getItem("num_serie");
        /*v.total = this.products.reduce((total, p) => {
					   return total + p.vl * p.quantity
					 }, 0);*/
        //alert(JSON.stringify(v.total));
      } else {
        if (
          localStorage.getItem("serie") == "MESA" ||
          localStorage.getItem("serie") == "mesa"
        ) {
          v.mesa = null;
          v.serie = localStorage.getItem("serie");
          v.num_serie = localStorage.getItem("num_serie");
          /*v.total = this.products.reduce((total, p) => {
				   return total + p.vl * p.quantity
				 }, 0);*/
        }
      }

      //v.venda=venda;
      if (
        localStorage.getItem("serie") == "" ||
        localStorage.getItem("num_serie") == "" ||
        localStorage.getItem("serie") == null ||
        localStorage.getItem("num_serie") == null
      ) {
        alert("Por favor, escolha um QR CODE da mesa.");
      } else {
        Venda.listarvenda(v.serie, v.num_serie).then((resposta) => {
          this.vendas = resposta.data;
          //alert("venda: "+resposta.data)
        });
      }
    },
  },
  mounted() {
    this.listarvenda();
  },
};
</script>
